var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import Input from '../../../Input';
import styled from 'styled-components';
import t from '../../../../lib/translate';
var StyledSearchWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #E9F1F8;\n  margin: 0 -4rem;\n  padding: 0.5rem 4rem;\n  input{\n    width: 100%;\n  }\n"], ["\n  background-color: #E9F1F8;\n  margin: 0 -4rem;\n  padding: 0.5rem 4rem;\n  input{\n    width: 100%;\n  }\n"])));
var GlobalFilter = function (_a) {
    var preGlobalFilteredRows = _a.preGlobalFilteredRows, globalFilter = _a.globalFilter, setGlobalFilter = _a.setGlobalFilter;
    var count = preGlobalFilteredRows.length;
    var _b = useState(globalFilter), value = _b[0], setValue = _b[1];
    var onChange = useAsyncDebounce(function (value) {
        setGlobalFilter(value || undefined);
    }, 200);
    return (_jsx(StyledSearchWrapper, { children: _jsx(Input, { autoFocus: true, value: value || '', label: t('table.search.header'), onChange: function (e) {
                setValue(e.target.value);
                onChange(e.target.value);
            }, placeholder: t('table.search.record.count', count) }) }));
};
export default GlobalFilter;
var templateObject_1;
